import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useListContext } from "@/modules/list";

const ListStatisticsCardExtra = ({ filterKey = "" }) => {
  const { t } = useTranslation();
  const { listParams, clearFilter } = useListContext();

  if (!listParams.filters?.[filterKey]) return null;

  return (
    <Button size="small" onClick={() => clearFilter(filterKey)}>
      {t("global:statistics:cardClearButton")}
    </Button>
  );
};

ListStatisticsCardExtra.propTypes = {
  filterKey: PropTypes.string.isRequired,
};

export default ListStatisticsCardExtra;
